import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const SettingsFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M18.3 11.96C18.3 12.44 18.48 12.9 18.88 13.34L20.14 14.64L18.42 17.66L16.68 17.32C15.48 17.1 14.6 17.52 14.34 18.6L13.84 20.38H10.16L9.66 18.6C9.4 17.52 8.52 17.1 7.32 17.32L5.58 17.66L3.86 14.64L5.12 13.34C5.52 12.9 5.7 12.44 5.7 11.96C5.7 11.46 5.5 10.96 5.12 10.58L3.86 9.3L5.58 6.26L7.32 6.6C8.52 6.82 9.4 6.4 9.66 5.32L10.16 3.54H13.84L14.34 5.32C14.6 6.4 15.48 6.82 16.68 6.6L18.42 6.26L20.14 9.28L18.88 10.58C18.48 11.02 18.3 11.46 18.3 11.96ZM12 14.48C13.38 14.48 14.52 13.34 14.52 11.96C14.52 10.58 13.38 9.44 12 9.44C10.62 9.44 9.48 10.58 9.48 11.96C9.48 13.34 10.62 14.48 12 14.48Z" />
    </SvgIcon>
  );
});
